'use strict';exports.__esModule = true;var _errorKeysData;var FIELD_NAMES = exports.FIELD_NAMES = {
    PUBLISH_LIMIT: 'publish_limit',
    COLOR_PROMOTION_LIMIT: 'color_promotion_limit',
    TOP_PROMOTION_LIMIT: 'top_promotion_limit' };


var EMPLOYEES_FIELD_NAMES = exports.EMPLOYEES_FIELD_NAMES = {
    NAME: 'name',
    LICENSE_NUMBER: 'license_number',
    PHONE_NUMBER: 'phone_number',
    VIRTUAL_NUMBER: 'virtual_number',
    IMAGE: 'image' };


var BASE_SEARCH_OPTIONS = exports.BASE_SEARCH_OPTIONS = [
{ label: 'Name', value: 'name' },
{ label: 'Phone', value: 'phone' }];


var SEARCH_OPTIONS = exports.SEARCH_OPTIONS = [
{ label: 'Email', value: 'email' }].concat(
BASE_SEARCH_OPTIONS);


var errorKeys = exports.errorKeys = {
    WRONG_PHONE_NUMBER: 'WRONG_PHONE_NUMBER',
    CANNOT_ASSIGN_YOURSELF: 'CANNOT_ASSIGN_YOURSELF',
    ALREADY_ASSIGNED: 'ALREADY_ASSIGNED',
    EXCEEDS_PUBLISH_LIMIT: 'EXCEEDS_PUBLISH_LIMIT',
    EXCEEDS_COLOR_PROMOTION_LIMIT: 'EXCEEDS_COLOR_PROMOTION_LIMIT',
    EXCEEDS_TOP_PROMOTION_LIMIT: 'EXCEEDS_TOP_PROMOTION_LIMIT',
    USER_NOT_ASSIGNED: 'USER_NOT_ASSIGNED',
    CANNOT_ASSIGN_REGULAR_USER: 'CANNOT_ASSIGN_REGULAR_USER',
    ALREADY_HAS_AGENCY: 'ALREADY_HAS_AGENCY',
    SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
    VIRTUAL_NUMBER_CREATION_FAILED: 'VIRTUAL_NUMBER_CREATION_FAILED',
    VIRTUAL_NUMBER_UPDATE_FAILED: 'VIRTUAL_NUMBER_UPDATE_FAILED' };


var errorKeysData = exports.errorKeysData = (_errorKeysData = {}, _errorKeysData[
errorKeys.WRONG_PHONE_NUMBER] = {
    title: 'wrong_phone_number' }, _errorKeysData[

errorKeys.CANNOT_ASSIGN_YOURSELF] = {
    title: 'cannot_assign_yourself',
    subTitle: 'goBackAndSelect' }, _errorKeysData[

errorKeys.ALREADY_ASSIGNED] = {
    title: 'already_assigned' }, _errorKeysData[

errorKeys.EXCEEDS_PUBLISH_LIMIT] = {
    title: 'exceeds_publish_limit' }, _errorKeysData[

errorKeys.EXCEEDS_COLOR_PROMOTION_LIMIT] = {
    title: 'exceeds_color_promotion_limit' }, _errorKeysData[

errorKeys.EXCEEDS_TOP_PROMOTION_LIMIT] = {
    title: 'exceeds_top_promotion_limit' }, _errorKeysData[

errorKeys.USER_NOT_ASSIGNED] = {
    title: 'user_not_assigned' }, _errorKeysData[

errorKeys.CANNOT_ASSIGN_REGULAR_USER] = {
    title: 'cannot_assign_regular_user' }, _errorKeysData[

errorKeys.ALREADY_HAS_AGENCY] = {
    title: 'already_has_agency' }, _errorKeysData[

errorKeys.VIRTUAL_NUMBER_CREATION_FAILED] = {
    title: 'virtual_number_creation_failed' }, _errorKeysData[

errorKeys.VIRTUAL_NUMBER_UPDATE_FAILED] = {
    title: 'virtual_number_update_failed' }, _errorKeysData[

errorKeys.SOMETHING_WENT_WRONG] = {
    title: 'something_went_wrong' }, _errorKeysData);



var getErrorKeyCase = exports.getErrorKeyCase = function getErrorKeyCase(key) {return errorKeysData[key] || errorKeysData.SOMETHING_WENT_WRONG;};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/Constants/index.js
// module id = 130
// module chunks = 0